import { useReportModalContext } from 'contexts/ReportModalContext';
import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaSearch } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './TemplateTab.css';
import { PaginationComponent } from 'pages/SearchPage/components/Pagination';

import { formatISO2DisplayDateString } from 'utils/dateFunctions';
import i18n from 'i18n';

export function TemplateTab({
  table, name, param, total, onGetMoreDocs,
}) {
  const { selectReport } = useReportModalContext();
  const [isTabOpen, setIsTabOpen] = useState('');
  const [paginationItemsPerPage, setPaginationItemsPerPage] = useState(5);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [loadedPages, setLoadedPages] = useState([0]);

  const totalNumberOfPages = Math.ceil(total / paginationItemsPerPage);
  const paginationStartIndex = currentPageIndex * paginationItemsPerPage;
  const paginationEndIndex = paginationStartIndex + paginationItemsPerPage;
  const slicedTable = table.slice(paginationStartIndex, paginationEndIndex);

  return (
    <>
      {slicedTable && (
        <div className="onlyResponsivePadding">
          <div className="displayFlex">
            <button className="dropdownTitleButton" onClick={() => setIsTabOpen(!isTabOpen)}>
              {isTabOpen
                ? <FaChevronUp className="templateTab-angleIcon" />
                : <FaChevronDown className="templateTab-angleIcon" />}
              <p className="dropdownTitle">
                {name}
              </p>
              <strong className="radius">{total}</strong>
            </button>
          </div>

          {!isTabOpen && <hr className="divisor" />}

          {
            isTabOpen
              ? (
                <div>

                  <div className="fakeHeader" />
                  <div className="listHeader spaceBetween">
                    <p className="listTitle">
                      { `Lista de ${name}`}
                    </p>
                    <FaSearch className="searchIcon" />
                  </div>

                  <div className="templateTab-tableHeader">
                    <p className="first">{param}</p>
                    <p>Descrição</p>
                    <p className="date">Data</p>
                  </div>

                  {slicedTable.map((document) => (
                    <>
                      <div className="templateTab-tableBody" key={document.id}>
                        <div
                          className="templateTab-tableRow"
                          onClick={() => selectReport({
                            idArg: document.binaryId,
                            practitioner: document.practitioner || 'Indisponível',
                            isoDate: document.date,
                          })}
                          role="button" tabIndex={0}
                        >
                          <p className="first">
                            {document.code || ' '}
                          </p>
                          <p className="description">
                            {document.description || 'Diagnóstico principal indisponível'}
                          </p>
                          <p className="date">
                            {formatISO2DisplayDateString(document.date, i18n.language) || 'Não encontrado'}
                          </p>
                        </div>
                      </div>
                      <hr className="divisor noPadding" />
                    </>
                  ))}
                  <PaginationComponent
                    pages={totalNumberOfPages}
                    currentPage={currentPageIndex}
                    setCurrentPage={(targetPageIndex) => {
                      if (!loadedPages.includes(targetPageIndex)) {
                        onGetMoreDocs();
                        setCurrentPageIndex(targetPageIndex);
                        setLoadedPages((prevState) => [...prevState, targetPageIndex]);
                      } else setCurrentPageIndex(targetPageIndex);
                    }}
                    setItensPerPage={setPaginationItemsPerPage}
                    items={paginationItemsPerPage}
                    totalItens={total}
                  />
                </div>
              )

              : <></>
          }

        </div>
      )}
    </>
  );
}

TemplateTab.propTypes = {
  table: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    code: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
    url: PropTypes.string,
    binaryId: PropTypes.string,
  })).isRequired,
  name: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  total: PropTypes.number,
  onGetMoreDocs: PropTypes.func,
};

TemplateTab.defaultProps = {
  onGetMoreDocs: () => {},
  total: 0,
};
